export default defineNuxtRouteMiddleware(async to => {
    const { checkAuthAndRedirect } = useAuthGuard();

    return await checkAuthAndRedirect(to, { preCheckSession: true });
});
